"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerTabController = exports.useDrawerTabContext = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const DrawerTabContext = react_1.createContext({
    selectedTabId: undefined,
    onSelectTab: lodash_1.default.noop,
});
exports.useDrawerTabContext = () => react_1.useContext(DrawerTabContext);
class DrawerTabController extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.onSelectTab = (tabId) => {
            if (this.props.onChanged) {
                this.props.onChanged(tabId);
            }
        };
    }
    getContext() {
        return {
            selectedTabId: this.props.selectedTabId,
            onSelectTab: this.onSelectTab,
        };
    }
    render() {
        const { children } = this.props;
        const contextValue = this.getContext();
        return (react_1.default.createElement(DrawerTabContext.Provider, { value: contextValue }, children instanceof Function ? children(contextValue) : children));
    }
}
exports.DrawerTabController = DrawerTabController;
DrawerTabController.defaultProps = {
    onChanged: lodash_1.default.noop,
};
